import { render, staticRenderFns } from "./VersionDetails.vue?vue&type=template&id=ade04830"
import script from "./VersionDetails.vue?vue&type=script&lang=ts"
export * from "./VersionDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports